import { render } from "./ReverseTokyoScreen.vue?vue&type=template&id=506b8527&scoped=true&ts=true&lang=pug"
import script from "./ReverseTokyoScreen.vue?vue&type=script&lang=ts"
export * from "./ReverseTokyoScreen.vue?vue&type=script&lang=ts"

import "./ReverseTokyoScreen.vue?vue&type=style&index=0&id=506b8527&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506b8527"]])

export default __exports__